import React from 'react';
import { createIcon } from 'native-base';
import { Path } from 'react-native-svg';
export const PencilIcon = createIcon({
    viewBox: '0 0 25 24',
    path: (React.createElement(Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 16.6671V20H7.83241L17.6608 10.1703L14.3284 6.83738L4.5 16.6671ZM20.2379 7.59283C20.5844 7.24622 20.5844 6.68629 20.2379 6.33967L18.1584 4.25996C17.8119 3.91335 17.252 3.91335 16.9054 4.25996L15.2792 5.8864L18.6116 9.21927L20.2379 7.59283Z" })),
});
